import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";



// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import {
  DevicesOther,
  Whatshot,
  Build,
  PermDataSetting,
  Security,
  TrendingUp
} from "@material-ui/icons";

import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";
import SectionCarousel from "./SectionCarousel.jsx";

class SectionService extends React.Component {
  render() {
    const { classes } = this.props;

 return (
     
      <div className={classes.section}>
        <h2 className={classes.title}>
          {" "}
          Information and Communication Technology Services
        </h2>
        <SectionCarousel />
          
           
           <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
          <div className={classes.section}>
            <h5 className={classes.description}>
             MGEC provide cloud computing, mobile application software
               development including eGovernment services, Enterprise Resource
              Planning (ERP), Point of Sales (POS), Queue Management System
              (QMS), Digital Signage technology, Cyber Security, Internet of
              Things(IoT), Industrial Control System and Blockchain Technology.
            </h5>
</div>
            </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Software Development"
              description="We provide eGovernment Services, POS Terminal, Queue Management and Enterprise Resource Planning (ERP)."
              icon={DevicesOther}
              iconColor="gray"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Telecommunication, Network and ISP"
              description="We provide Triple-Play Broadband Network Design, Residential & Enterprise Systems Implementation, CPE and Digital Voice Integration."
              icon={PermDataSetting}
              iconColor="gray"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Industrial Control & Automation Systems"
              description="We provide PLC, SCADA and DCS, Water Treatment & Distribution Systems."
              icon={Build}
              iconColor="gray"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Cyber Physical System Security"
              description="We provide Critical Infrastructure, Internet of Things (IoT)."
              icon={Security}
              iconColor="gray"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Digital Technologies for Smart Nation"
              description="We provide System Design, Sensors and Info-Communication, Cloud Computing and Data Analytics, Mobile Application Development."
              icon={TrendingUp}
              iconColor="gray"
              vertical
            />
          </GridItem>
            
              <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Data Centre M&E Facility Management"
                description="We provide Critical Power and Cooling ,UPS for Banks, Hospitals, Airports, etc."                             
                icon={Whatshot}
                iconColor="gray"
                vertical
              />
            </GridItem>
            </GridContainer>
           <br />
                
 
         
      </div>

    );
  }
}

export default withStyles(workStyle)(SectionService);



// WEBPACK FOOTER //
// ./src/views/ICTPage/Sections/SectionService.jsx